import { useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

declare global {
  interface Window {
    __customFetchWrapped?: boolean;
    __routeRequestMap?: Record<string, number>;
  }
}

// Init fetch wrapper én gang
const originalFetch = window.fetch;

if (!window.__customFetchWrapped) {
  window.__routeRequestMap = {}; // 💡 Hver rute har sin egen teller

  window.fetch = async (...args) => {
    const route = window.location.pathname;
    window.__routeRequestMap![route] = (window.__routeRequestMap![route] || 0) + 1;

    try {
      return await originalFetch(...args);
    } finally {
      window.__routeRequestMap![route]--;
    }
  };

  window.__customFetchWrapped = true;
}

export function useRoutePerformance(appInsightsInstance?: ApplicationInsights) {
  const location = useLocation();
  const startTimeRef = useRef<number>(0);

  useEffect(() => {
    if (!appInsightsInstance) return;

    const currentRoute = location.pathname;
    startTimeRef.current = performance.now();

    const timer = setInterval(() => {
      const active = window.__routeRequestMap?.[currentRoute] || 0;

      if (active === 0) {
        const endTime = performance.now();
        const duration = Math.round(endTime - startTimeRef.current);

        appInsightsInstance.trackEvent({
          name: 'PageReady',
          properties: {
            route: currentRoute,
            duration,
          },
        });

        clearInterval(timer);
      }
    }, 100);

    return () => clearInterval(timer); // Rydd opp ved rutenavigasjon
  }, [location.pathname, appInsightsInstance]);
}